/* Simulador de frete da pagina de produto — La Ganexa.
 *
 * HISTORICO: a versao original deste arquivo consultava /cart/shipping_rates.json, ou
 * seja, o frete da SHOPIFY — servido pelo app da Frenet, que continuou ativo como
 * transportadora na Shopify mesmo depois de a Frenet ser desligada no checkout (Yampi).
 * Resultado: a vitrine anunciava preco e prazo DIFERENTES do checkout, chegando a
 * mostrar o DOBRO do frete real (ex: Jadlog.Package R$18 na pagina x R$8,88 no checkout).
 *
 * AGORA: a vitrine chama a MESMA engine do checkout (worker /simular), e o worker resolve
 * o peso pelo SKU no cadastro da YAMPI — a mesma fonte que o checkout usa para cobrar.
 * Isso importa porque o peso vive em dois cadastros independentes: a Shopify tinha 0g
 * nos SKU 697/698 e 1,2kg no SKU 35 (contra 0,1kg na Yampi). Confiando na Yampi, a
 * pagina mostra exatamente o que o cliente vai pagar, independente do que a Shopify tenha.
 *
 * Outras correcoes em relacao a versao original:
 *   - nao adiciona o produto no carrinho nem troca o cookie do carrinho para cotar
 *     (o script antigo fazia /cart/add.js com um cookie falso e podia sujar o carrinho);
 *   - mostra os centavos (o antigo usava amount_no_decimals e escondia, exibindo "R$ 18");
 *   - nao reinjeta o formulario a cada calculo (o antigo tinha uma IIFE duplicada).
 *
 * ROLLBACK: o conteudo original esta em Frete/theme/quickShipping-original.js e nos temas
 * anteriores (nao publicados). Publicar um tema anterior restaura tudo.
 */
(function () {
  "use strict";

  var ENDPOINT = "https://laganexa-frete.pastalaganexa.workers.dev/simular";

  var alvo = document.getElementsByClassName("frete-produto")[0];
  if (!alvo) return;

  var wrapper = document.createElement("div");
  wrapper.className = "shipping-calc-wrapper";

  var form = document.createElement("div");
  form.className = "formulario-frete";

  var input = document.createElement("input");
  input.type = "text";
  input.inputMode = "numeric";
  input.className = "Form__Input cep-calculo-frete form-control";
  input.placeholder = "DIGITE SEU CEP";
  input.setAttribute("aria-label", "CEP para simular o frete");

  var botao = document.createElement("a");
  botao.href = "#";
  botao.innerText = "Calcular";
  botao.className = "btn btn-underline button button--primary";

  var erro = document.createElement("p");
  erro.className = "erros-fretes";
  erro.style.display = "none";

  var lista = document.createElement("div");
  lista.className = "listas-de-fretes";
  lista.style.display = "none";

  form.appendChild(input);
  form.appendChild(botao);
  wrapper.appendChild(form);
  wrapper.appendChild(erro);
  wrapper.appendChild(lista);
  alvo.appendChild(wrapper);

  if (window.jQuery && jQuery.fn && jQuery.fn.mask) {
    jQuery(input).mask("00.000-000");
  } else {
    input.addEventListener("input", function () {
      var d = input.value.replace(/\D/g, "").slice(0, 8);
      input.value = d.length > 5 ? d.slice(0, 2) + "." + d.slice(2, 5) + "-" + d.slice(5) : d;
    });
  }

  function dinheiro(v) {
    return "R$ " + Number(v).toFixed(2).replace(".", ",");
  }

  function mostrarErro(msg) {
    lista.style.display = "none";
    lista.innerHTML = "";
    erro.innerHTML = msg;
    erro.style.display = "flex";
  }

  function limparErro() {
    erro.innerHTML = "";
    erro.style.display = "none";
  }

  function carregando() {
    erro.style.display = "none";
    lista.style.display = "";
    lista.innerHTML =
      "<img id='loading-icon-frete' src='https://cdn.shopify.com/s/files/1/2184/2809/files/loading-buffering.gif?v=1621716543' " +
      "width='30' style='width:30px;height:30px;margin:0 auto' alt='Calculando'>";
  }

  function quantidade() {
    var el = document.getElementById("Quantity") || document.querySelector('[name="quantity"]');
    var n = el ? parseInt(el.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function handleDoProduto() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  // Peso da variante em kg, so como PALPITE (o worker prefere o peso da Yampi).
  // /products/{handle}.js devolve o peso em `weight` (+ `weight_unit`) e deixa `grams`
  // NULO — diferente de /products.json, que usa `grams`. Por isso lemos os dois campos.
  function pesoKg(v) {
    var g = Number(v.grams);
    if (g > 0) return g / 1000;
    var w = Number(v.weight) || 0;
    if (!w) return 0;
    switch (String(v.weight_unit || "g").toLowerCase()) {
      case "kg": return w;
      case "lb": return w * 0.45359237;
      case "oz": return w * 0.0283495;
      default: return w / 1000;
    }
  }

  function idVarianteSelecionada() {
    var el = document.getElementById("ProductSelect-product-template") || document.getElementsByName("id")[0];
    var v = el && el.value ? parseInt(el.value, 10) : NaN;
    return isNaN(v) ? null : v;
  }

  function variante() {
    var handle = handleDoProduto();
    if (!handle) return Promise.reject(new Error("sem handle"));
    return fetch("/products/" + handle + ".js", { credentials: "same-origin" })
      .then(function (r) {
        if (!r.ok) throw new Error("produto " + r.status);
        return r.json();
      })
      .then(function (prod) {
        var id = idVarianteSelecionada();
        var v = (id && (prod.variants || []).filter(function (x) { return x.id === id; })[0]) || (prod.variants || [])[0];
        if (!v) throw new Error("sem variante");
        return v;
      });
  }

  function render(quotes) {
    lista.innerHTML = "";
    if (!quotes || !quotes.length) {
      mostrarErro("Não encontramos frete para este CEP. Confira o número e tente novamente.");
      return;
    }
    quotes.forEach(function (q) {
      var valor = q.free_shipment || Number(q.price) === 0 ? "Grátis" : dinheiro(q.price);
      var prazo = Number(q.days) > 1 ? q.days + " dias úteis" : q.days + " dia útil";
      var item = document.createElement("div");
      item.className = "frete-item";
      item.innerHTML =
        '<div><p class="m-0 nome-frete"><b></b> <span class="estimativa-de-entrega"></span></p></div>' +
        '<div class="frete-valor">Valor: <b></b></div>';
      item.querySelector(".nome-frete b").textContent = q.name;
      item.querySelector(".estimativa-de-entrega").textContent = prazo;
      item.querySelector(".frete-valor b").textContent = valor;
      lista.appendChild(item);
    });
    lista.style.display = "";
  }

  function calcular() {
    var cep = input.value.replace(/\D/g, "");
    limparErro();
    if (cep.length !== 8) {
      mostrarErro("Digite um CEP válido, com 8 números.");
      return;
    }
    carregando();

    variante()
      .then(function (v) {
        var qtd = quantidade();
        var totalLinha = (Number(v.price) || 0) / 100 * qtd;
        // O peso vai como PALPITE apenas. Quem manda e o cadastro da Yampi, que o worker
        // consulta pelo SKU — a mesma fonte que o checkout usa para cobrar. Por isso nao
        // desistimos quando a Shopify esta com peso zero: o worker resolve.
        var kg = pesoKg(v);
        return fetch(ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            zipcode: cep,
            amount: totalLinha,
            skus: [{ sku: String(v.sku || ""), weight: kg, quantity: qtd, price: totalLinha }],
          }),
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error("cotacao " + r.status);
        return r.json();
      })
      .then(function (d) {
        render(d.quotes);
      })
      .catch(function (e) {
        if (window.console) console.error("[frete] falha ao simular:", e);
        mostrarErro("Não conseguimos calcular o frete agora. Tente novamente em instantes.");
      });
  }

  botao.addEventListener("click", function (ev) {
    ev.preventDefault();
    calcular();
  });
  input.addEventListener("keydown", function (ev) {
    if (ev.key === "Enter") {
      ev.preventDefault();
      calcular();
    }
  });
})();
